module.exports = __webpack_public_path__ + "static/img/zhi.1a1bb9bb.png";